module.exports = __webpack_public_path__ + "media/KikiNick.2f2e7128.mp3";